// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-422c3b9f],.fade-leave-active[data-v-422c3b9f]{transition:all .5s ease-out}.fade-enter[data-v-422c3b9f],.fade-leave-to[data-v-422c3b9f]{opacity:0}", ""]);
// Exports
module.exports = exports;
